import InvalidStructureTable from './InvalidStructureTable'

export default InvalidStructureTable
